import { Component, OnInit } from "@angular/core";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { ContentManagementService } from "./content-management.service";

@Component({
  selector: "app-content-management",
  templateUrl: "./content-management.component.html",
  styleUrls: ["./content-management.component.css"],
})
export class ContentManagementComponent implements OnInit {
  cmsList = [];
  formObj = {};
  // errorObj = {};
  cms: boolean = false;
  constructor(
    private CmsService: ContentManagementService,
    private notif: NotificationsService,
    private userService: UserService
  ) {
    this.loadTableData();
  }
  loadTableData() {
    this.CmsService.geAllCms().subscribe((res) => {
      this.cmsList = res.data;
    });
  }

  resetForm() {
    for (const key in this.formObj) {
      this.formObj[key] = "";
    }
    this.loadTableData();
  }

  cmsForm(obj: any, editableObj = null) {
    if (obj == "show") {
      this.cms = true;
    } else if (obj == "hide") {
      this.cms = false;
    }
    if (editableObj) {
      this.formObj = editableObj;
    }
  }
  addCms(cms) {
    this.userService.csrf().subscribe((success) => {
      this.formObj["_csrf"] = success._csrf;
      this.CmsService.saveCms(this.formObj).subscribe(
        (response) => {
          this.notif.success("Success", response.data.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
          cms.resetForm({});
          this.resetForm();
        },
        (err) => {
          this.notif.error("Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    });
  }
  deleteCms(cms) {
    this.CmsService.deleteCms(cms).subscribe((response) => {
      this.notif.success("Deleted successfully", response.data.message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      });
      this.resetForm();
    });
  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/content-management/content-management.component.ts